import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

/** Служебные разделы, которым нечего делать в поиске */
const NOINDEX_PREFIXES = ["/payment", "/auth", "/console", "/tg"];

/**
 * Проставляет noindex для служебных маршрутов и для всего staging-окружения.
 * Публичные страницы задают robots самостоятельно через компонент <Seo>.
 */
export const NoIndexMeta = (): JSX.Element | null => {
  const { pathname } = useLocation();
  const isStaging = import.meta.env.VITE_ENVIRONMENT === "staging";
  const isServicePath = NOINDEX_PREFIXES.some(prefix => pathname === prefix || pathname.startsWith(`${prefix}/`));

  if (!isStaging && !isServicePath) {
    return null;
  }

  return (
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
  );
};
